import { render, staticRenderFns } from "./locations.vue?vue&type=template&id=07b0161b&scoped=true"
import script from "./locations.vue?vue&type=script&lang=js"
export * from "./locations.vue?vue&type=script&lang=js"
import style0 from "./locations.vue?vue&type=style&index=0&id=07b0161b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b0161b",
  null
  
)

export default component.exports